// src/beta/components/slides/DocumentSlide.tsx
import type { V1Slide } from '@/beta/types/story';

interface Props { slide: V1Slide; }

/** Document slide — eyebrow + title + outlined "View" CTA pointing at the
 *  signed-URL endpoint (/api/v1/documents/[docId]). Opens in new tab. */
export function DocumentSlide({ slide }: Props) {
  const docId = slide.block.documentId;
  const title = slide.block.documentTitle ?? slide.block.caption ?? 'Document';
  const eyebrow = slide.block.caption;

  return (
    <div
      style={{
        width: '100%',
        height: '100%',
        background: 'var(--vm-dark)',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        padding: 'var(--vm-s-8)',
        textAlign: 'center',
        color: 'var(--vm-warm-white)',
      }}
    >
      {eyebrow && (
        <div
          style={{
            fontFamily: 'var(--vm-font-heading)',
            fontSize: 11,
            letterSpacing: '0.4em',
            textTransform: 'uppercase',
            color: 'var(--vm-red)',
            marginBottom: 'var(--vm-s-3)',
          }}
        >
          {eyebrow}
        </div>
      )}

      <h2
        style={{
          fontFamily: 'var(--vm-font-heading)',
          fontSize: 40,
          letterSpacing: '0.03em',
          lineHeight: 1.15,
          maxWidth: 800,
          margin: 0,
        }}
      >
        {title}
      </h2>

      {docId && (
        <a
          href={`/api/v1/documents/${docId}`}
          target="_blank"
          rel="noopener noreferrer"
          style={{
            marginTop: 'var(--vm-s-6)',
            color: 'var(--vm-red)',
            fontFamily: 'var(--vm-font-heading)',
            fontSize: 13,
            letterSpacing: '0.3em',
            textTransform: 'uppercase',
            textDecoration: 'none',
            border: '1px solid var(--vm-red)',
            padding: '14px 22px',
          }}
        >
          View Document →
        </a>
      )}
    </div>
  );
}
